export default __webpack_public_path__ + "img/disclaimer.jpg";